import { isMobile } from '@pascal/pascal-core';

const animationDefaultDelays = {
  // JetsBackground START
  fightersSky: isMobile() ? 4080 : 5100,
  skyLoop: isMobile() ? 5780 : 6800,
  jetsGround: isMobile() ? 4080 : 5100,
  jetsGroundInner: 3400,
  /* JetsBackground END */

  /* JetsDust START */
  smokeBrake: 0,
  smokeFly: 0,
  /* JetsDust END */

  /* Jets START */
  jetPlane: 0,
  launchPad: 2400,
  jetsFlamesOrange: 0,
  jetsFlamesBlue: 3400,
  /* Jets END */

  /* FLY OBJECTS START */
  moon: 6000,
  asteroid: 15000,
  airplane: 13000,
  /* FLY OBJECTS END */
};

export { animationDefaultDelays };
